import React, { useState } from "react";
import "../../App.css";

interface WeatherLayerProps {
  messureUnitLayer: string;
}

const MessureUnits: React.FC<WeatherLayerProps> = ({ messureUnitLayer}) => {

  return (
    <>{messureUnitLayer==="windnot" &&(
      <div
      className="messure-units"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr repeat(7, 1fr)", 

        gap: "5px",
        backdropFilter: "blur(5.5px)",
        WebkitBackdropFilter: "blur(5.5px)",
        background:"linear-gradient(to right,var(--legend-color),var(--legend-color),var(--legend-color), rgb(71, 82, 172), rgb(56,	165,	251,0.4),rgb(35, 230, 177),rgb(16, 244, 12), rgb(219, 224, 54), rgb(235, 214, 59), rgb(247, 187, 55), rgb(228, 164, 27), rgb(253, 159, 46), rgb(231, 30, 7),rgb(240, 12, 130), rgb(131, 15, 157), rgb(101, 13, 155), rgb(156, 17, 2),rgb(139, 10, 2), rgb(122, 4, 3))"
      }}
    >
     <span style={{ width: "12.5%", marginLeft:"6px", whiteSpace: 'nowrap'}}>m/s</span>
     <span style={{ width: "12.5%" }}>0</span>
     <span style={{ width: "12.5%" }}>10</span>
     <span style={{ width: "12.5%" }}>12</span>
     <span style={{ width: "12.5%" }}>15</span>
     <span style={{ width: "12.5%" }}>19</span>
     <span style={{ width: "12.5%" }}>25</span>
     <span style={{ width: "12.5%" }}>35</span>

    </div>
    )}
    {messureUnitLayer==="temperaturenot" &&(
      <div
      className="messure-units"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr repeat(9, 1fr)", 
        gap: "5px",
        backdropFilter: "blur(5.5px)",
        WebkitBackdropFilter: "blur(5.5px)",
        background:"linear-gradient(to right, rgb(189, 124, 245), rgb(169, 81, 246), rgb(149, 37, 247), rgb(116, 51, 249), rgb(69, 119, 252),rgb(24, 196, 254), rgb(36, 226, 252), rgb(69, 240, 249), rgb(81, 238, 225),rgb(64, 222, 179),rgb(36, 198, 121), rgb(53, 192, 73), rgb(55, 145, 39), rgb(238, 250, 10), rgb(238, 250, 10),rgb(222, 17, 6),rgb(222, 17, 6), rgb(93, 9, 9),  rgb(93, 9, 9))"
      }}
    >
     <span style={{ width: "10%", marginLeft:"6px" }}>°C</span>
     <span style={{ width: "10%" }}>-34</span>
     <span style={{ width: "10%" }}>-23</span>
     <span style={{ width: "10%" }}>-12</span>
     <span style={{ width: "10%" }}>-1</span>
     <span style={{ width: "10%" }}>4</span>
     <span style={{ width: "10%" }}>10</span>
     <span style={{ width: "10%" }}>20</span>
     <span style={{ width: "10%" }}>32</span>
     <span style={{ width: "10%" }}>42</span>

    </div>
    )}
        {messureUnitLayer==="rainnot" &&(
      <div
      className="messure-units"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr repeat(7, 1fr)", 
        gap: "5px",
        backdropFilter: "blur(5.5px)",
        WebkitBackdropFilter: "blur(5.5px)",
        background:"linear-gradient(to right, var(--legend-color),var(--legend-color),var(--legend-color),rgb(202, 255, 253,0.62), rgb(131, 244, 231), rgb(1, 217, 232), rgb(51, 173, 249), rgb(69, 119, 252),rgb(93, 98, 233),rgb(84, 113, 199),rgb(41, 164, 151),rgb(33, 190, 127),rgb(39, 200, 48),rgb(160, 230, 53),rgb(247, 251, 55),rgb(240, 230, 10),rgb(238, 136, 8),rgb(212, 31, 6),rgb(161, 13, 7),rgb(139, 14, 7),rgb(93, 9, 9),rgb(93, 9, 9)  )"
      }}
    >
     <span style={{ width: "10%", marginLeft:"6px" }}>mm</span>
     <span style={{  width: "10%" }}>1</span>
     <span style={{ width: "10%" }}>70</span>
     <span style={{  width: "10%" }}>150</span>
     <span style={{ width: "10%" }}>250</span>
     <span style={{  width: "10%"}}>390</span>
     <span style={{ width: "10%" }}>450</span>
     <span style={{  width: "10%"}}>600</span>
    </div>
    )} {messureUnitLayer==="airPressurenot" &&(
      <div
      className="messure-units"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr repeat(5, 1fr)", 
        gap: "5px",
        backdropFilter: "blur(5.5px)",
        WebkitBackdropFilter: "blur(5.5px)",
        background:"linear-gradient(to right, rgb(234,1,255),rgb(234,1,255),rgb(234,1,255), rgb(234,1,255),rgb(208,11,61), rgb(19,65,119), rgb(130,67,231), rgb(14,147,107), rgb(94,247,114), rgb(158,246,72), rgb(213,225,53), rgb(243,181,51), rgb(245,125,32), rgb(223,73,13), rgb(180,33,4),rgb(122,4,3),rgb(122,4,3))"
      }}
    >
     <span style={{ width: "16.66%", marginLeft:"6px" }}>hPa</span>
     <span style={{  width: "16.66%" }}>900</span>
     <span style={{ width: "16.66%" }}>968</span>
     <span style={{  width: "16.66%" }}>997</span>
     <span style={{ width: "16.66%" }}>1025</span>
     <span style={{  width: "16.66%"}}>1054</span>
    </div>
    )}
    </>
  );
};

export default MessureUnits;
